import { Button } from "@progress/kendo-react-buttons";
import { GridCellProps } from "@progress/kendo-react-grid";
import DeleteDataItemDialog from "../grid/DeleteDataItemDialog";

interface Commands {
  editField?: string;
  idField?: string;
  description?: string;
  disabled?: boolean;
  onAdd(dataItem: any): void;
  onUpdate(dataItem: any): void;
  onDiscard(dataItem: any): void;
  onCancel(dataItem: any): void;
  onEdit(dataItem: any): void;
  onRemove(id: number): void;
}

type GridCommandCellProps = Commands & GridCellProps;

const GridCommandCell = ({
  dataItem,
  editField = "inEdit",
  idField = "id",
  description,
  disabled = false,
  onAdd,
  onUpdate,
  onDiscard,
  onCancel,
  onEdit,
  onRemove,
}: GridCommandCellProps) => {
  const inEdit = dataItem[editField];
  const isNewItem = !dataItem[idField];

  const handleClickConfirm = () => {
    isNewItem ? onAdd(dataItem) : onUpdate(dataItem);
  };

  const handleClickCancel = () => {
    isNewItem ? onDiscard(dataItem) : onCancel(dataItem);
  };

  const handleClickEdit = () => {
    onEdit(dataItem);
  };

  const handleDelete = () => {
    onRemove(dataItem[idField]);
  };

  return inEdit ? (
    <td>
      <Button
        onClick={handleClickConfirm}
        icon="save"
        size="small"
        themeColor="primary"
        fillMode="outline"
        title="Save"
      ></Button>
      <Button
        onClick={handleClickCancel}
        icon={isNewItem ? "trash" : "cancel"}
        size="small"
        themeColor="primary"
        fillMode="outline"
        title={isNewItem ? "Discard" : "Cancel"}
      ></Button>
    </td>
  ) : (
    <td>
      <Button
        onClick={handleClickEdit}
        disabled={disabled}
        icon="pencil"
        size="small"
        themeColor="primary"
        fillMode="outline"
        title="Edit"
      />

      <DeleteDataItemDialog description={description} disabled={disabled} onDelete={handleDelete} />
    </td>
  );
};

export { GridCommandCell };
export type { Commands };
